'use client';

import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import styles from './index.module.scss';
import useCard from './useCard';

interface SliderProps {
  imgUrl: string;
  title: string;
  description: string;
  details?: string;
}

const Card: React.FC<SliderProps> = ({
  imgUrl,
  title,
  description,
  details,
}) => {
  const { showOverlay, setShowOverlay } = useCard();

  return (
    <motion.div
      className={styles.container}
      onHoverStart={() => setShowOverlay(true)}
      onHoverEnd={() => setShowOverlay(false)}
    >
      <AnimatePresence>
        {showOverlay && (
          <motion.div
            className={styles.overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div />
          </motion.div>
        )}
      </AnimatePresence>
      <div className={styles.imageContainer}>
        <Image
          src={imgUrl}
          alt={title}
          sizes="100vw"
          style={{
            width: '100%',
            height: 'auto',
          }}
          width={500}
          height={300}
        />
      </div>
      <div className={styles.textContainer}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <p className={styles.details}>{details}</p>
      </div>
    </motion.div>
  );
};

export default Card;
